const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_reaction: 'e904',
  addmember_filled: 'e905',
  adduser: 'e906',
  admin: 'e907',
  animals: 'e908',
  animations: 'e909',
  archive: 'e90a',
  arrow_down: 'e90b',
  arrow_next: 'e90c',
  arrowcircle: 'e90d',
  attach: 'e90e',
  audio_repeat: 'e90f',
  audio_repeat_single: 'e910',
  avatarnext: 'e911',
  avatarprevious: 'e912',
  binfilled: 'e913',
  bold: 'e914',
  bomb: 'e915',
  boost: 'e916',
  boostcircle: 'e917',
  botcom: 'e918',
  bots: 'e919',
  bug: 'e91a',
  calendar: 'e91b',
  calendarfilter: 'e91c',
  camera: 'e91d',
  cameraadd: 'e91e',
  car: 'e91f',
  card: 'e920',
  card_outline: 'e921',
  channel: 'e922',
  channelviews: 'e923',
  chatspinned: 'e924',
  chatsplaceholder: 'e925',
  check1: 'e926',
  checkbox: 'e927',
  checkboxblock: 'e928',
  checkboxempty: 'e929',
  checkboxon: 'e92a',
  checkretract: 'e92b',
  checkround: 'e92c',
  checkround_filled: 'e92d',
  clock: 'e92e',
  close: 'e92f',
  clouddownload: 'e930',
  colorize: 'e931',
  comments: 'e932',
  commentssticker: 'e933',
  copy: 'e934',
  crossround: 'e935',
  darkmode: 'e936',
  data: 'e937',
  delete: 'e938',
  delete_filled: 'e939',
  deletedaccount: 'e93a',
  deleteleft: 'e93b',
  deleteuser: 'e93c',
  devices: 'e93d',
  document: 'e93e',
  down: 'e93f',
  download: 'e940',
  dragfiles: 'e941',
  dragmedia: 'e942',
  eats: 'e943',
  edit: 'e944',
  email: 'e945',
  endcall_filled: 'e946',
  enter: 'e947',
  eye: 'e948',
  eye1: 'e949',
  eye2: 'e94a',
  eyecross_outline: 'e94b',
  fast_forward: 'e94c',
  fast_rewind: 'e94d',
  favourites: 'e94e',
  flag: 'e94f',
  flip: 'e950',
  folder: 'e951',
  fontsize: 'e952',
  forward: 'e953',
  forward_filled: 'e954',
  fullscreen: 'e955',
  gc_microphone: 'e956',
  gc_microphoneoff: 'e957',
  gifs: 'e958',
  gift: 'e959',
  gift_premium: 'e95a',
  group: 'e95b',
  group_filled: 'e95c',
  groupmedia: 'e95d',
  groupmediaoff: 'e95e',
  help: 'e95f',
  hide: 'e960',
  image: 'e961',
  info: 'e962',
  info2: 'e963',
  italic: 'e964',
  keyboard: 'e965',
  lamp: 'e966',
  language: 'e967',
  largepause: 'e968',
  largeplay: 'e969',
  left: 'e96a',
  limit_chat: 'e96b',
  limit_chats: 'e96c',
  limit_file: 'e96d',
  limit_folders: 'e96e',
  limit_link: 'e96f',
  limit_pin: 'e970',
  link: 'e971',
  list: 'e972',
  listscreenshare: 'e973',
  livelocation: 'e974',
  location: 'e975',
  lock: 'e976',
  lockoff: 'e977',
  loginlogodesktop: 'e978',
  loginlogomobile: 'e979',
  logout: 'e97a',
  mediaspoiler: 'e97b',
  mediaspoileroff: 'e97c',
  mention: 'e97d',
  menu: 'e97e',
  message: 'e97f',
  message_jump: 'e980',
  message_quote: 'e981',
  messageunread: 'e982',
  microphone: 'e983',
  microphone_crossed: 'e984',
  microphone_crossed_filled: 'e985',
  microphone_filled: 'e986',
  minus: 'e987',
  monospace: 'e988',
  more: 'e989',
  multistories: 'e98a',
  mute: 'e98b',
  muted: 'e98c',
  newchannel: 'e98d',
  newchannel_filled: 'e98e',
  newchat_filled: 'e98f',
  newgroup: 'e990',
  newgroup_filled: 'e991',
  newprivate: 'e992',
  newprivate_filled: 'e993',
  newtab: 'e994',
  next: 'e995',
  noncontacts: 'e996',
  nosound: 'e997',
  online: 'e998',
  passwordoff: 'e999',
  pause: 'e99a',
  permissions: 'e99b',
  phone: 'e99c',
  phone_filled: 'e99d',
  pin: 'e99e',
  pinlist: 'e99f',
  pinned_filled: 'e9a0',
  pinnedchat: 'e9a1',
  pip: 'e9a2',
  play: 'e9a3',
  playback_05: 'e9a4',
  playback_15: 'e9a5',
  playback_1x: 'e9a6',
  playback_2x: 'e9a7',
  plus: 'e9a8',
  plusround: 'e9a9',
  poll: 'e9aa',
  premium_addone: 'e9ab',
  premium_avatars: 'e9ac',
  premium_badge: 'e9ad',
  premium_double: 'e9ae',
  premium_emoji: 'e9af',
  premium_filesize: 'e9b0',
  premium_limits: 'e9b1',
  premium_lock: 'e9b2',
  premium_management: 'e9b3',
  premium_noads: 'e9b4',
  premium_reactions: 'e9b5',
  premium_speed: 'e9b6',
  premium_status: 'e9b7',
  premium_stickers: 'e9b8',
  premium_transcription: 'e9b9',
  premium_translate: 'e9ba',
  premium_unlock: 'e9bb',
  previous: 'e9bc',
  promote: 'e9bd',
  quote: 'e9be',
  quote_outline: 'e9bf',
  radiooff: 'e9c0',
  radioon: 'e9c1',
  reactions: 'e9c2',
  reactions_filled: 'e9c3',
  readchats: 'e9c4',
  recent: 'e9c5',
  replace: 'e9c6',
  reply: 'e9c7',
  reply_filled: 'e9c8',
  restrict: 'e9c9',
  rightpanel: 'e9ca',
  rotate_left: 'e9cb',
  rotate_right: 'e9cc',
  saved: 'e9cd',
  savedmessages: 'e9ce',
  schedule: 'e9cf',
  scheduled: 'e9d0',
  search: 'e9d1',
  select: 'e9d2',
  send: 'e9d3',
  send2: 'e9d4',
  sending: 'e9d5',
  sendingerror: 'e9d6',
  settings: 'e9d7',
  settings_filled: 'e9d8',
  sharescreen_filled: 'e9d9',
  shipping: 'e9da',
  shuffle: 'e9db',
  smallscreen: 'e9dc',
  smile: 'e9dd',
  speaker: 'e9de',
  speakerfilled: 'e9df',
  speakeroff: 'e9e0',
  speakerofffilled: 'e9e1',
  spoiler: 'e9e2',
  sport: 'e9e3',
  star: 'e9e4',
  star_filled: 'e9e5',
  stickers: 'e9e6',
  stickers_face: 'e9e7',
  stop: 'e9e8',
  stories: 'e9e9',
  storyreply: 'e9ea',
  strikethrough: 'e9eb',
  textedit: 'e9ec',
  timer: 'e9ed',
  tip: 'e9ee',
  tools: 'e9ef',
  topics: 'e9f0',
  transcribe: 'e9f1',
  unarchive: 'e9f2',
  underline: 'e9f3',
  unmute: 'e9f4',
  unpin: 'e9f5',
  unread: 'e9f6',
  up: 'e9f7',
  user: 'e9f8',
  username: 'e9f9',
  videocamera: 'e9fa',
  videocamera_crossed_filled: 'e9fb',
  videocamera_filled: 'e9fc',
  videochat: 'e9fd',
  volume_down: 'e9fe',
  volume_mute: 'e9ff',
  volume_off: 'ea00',
  volume_up: 'ea01',
  webview: 'ea02',
  zoomin: 'ea03',
  zoomout: 'ea04'
};

export default Icons;
